import { slideDown, slideUp, isVisible } from 'slide-anim';
import attrs from 'attrs';

export const accordion = () => {
  const elements = document.querySelectorAll('.accordion');

  elements.forEach(element => {
    const triggers = element.querySelectorAll('.accordion__panel-title, .accordion__panel-status');
    const panels = element.querySelectorAll('.accordion__panel-body');

    const openAccordion = () => {
      panels.forEach(panel => {
        const title = panel.previousElementSibling;

        if (!isVisible(panel)) {
          slideDown(panel);

          attrs(title, {
            'aria-selected': true
          })
        }
      });
    };

    const collapseAccordion = () => {
      panels.forEach(panel => {
        const title = panel.previousElementSibling;

        if (isVisible(panel)) {
          slideUp(panel);

          attrs(title, {
            'aria-selected': false
          });
        }
      });
    };

    const handlePanelsToggle = event => {
      let trigger = event.target;

      if (trigger.classList.contains('accordion__panel-status')) {
        trigger = trigger.parentNode;
      }

      const panel = trigger.nextElementSibling;

      // to focus removes from title when pressed a key
      if (event.key && event.key !== 'Enter') return;

      if (isVisible(panel)) {
        slideUp(panel);
        attrs(trigger, {
          'aria-selected': false
        })
      } else {
        slideDown(panel);
        attrs(trigger, {
          'aria-selected': true
        })
      }

      if (!element.getAttribute("aria-multiselectable")) {
        collapseAccordion();
      }
    };

    triggers.forEach(trigger => {
      trigger.addEventListener('click', handlePanelsToggle);
      trigger.addEventListener('keyup', handlePanelsToggle);
    });
    console.log(element.dataset.openedPanels);
    if (element.dataset.openedPanels === 'true') {
      
      openAccordion();
    };
  });
};
